import moment from 'moment'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sendStaffAppMetaData } from '../../eventTriggers'

export function TreatmentCenterHistory() {
  const { config, treatment_centers } = useSelector(state=>state)
  const tabDefaultMetaData = useSelector(state=>state.config.tab_default_meta_data.find(tab=> tab.detail == 'treatment_center_history'))
  const dispatch = useDispatch()

  function handleClick(resource){
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "treatmentCenter",
        resource
      }
    })
    sendStaffAppMetaData(tabDefaultMetaData.modal)
  }

  return (
    <div>
      {
        treatment_centers.map(treatment_center=>(
          <div onClick={()=>handleClick(treatment_center)} key={treatment_center.id} className="p-4 border-bottom">
            <b>{treatment_center.name}</b>
            {
              (!!treatment_center.started_at || !!treatment_center.ended_at) &&
              <div>
                { !!treatment_center.started_at ? moment(treatment_center.started_at).format("MM/DD/YYYY") : 'Unkown' }
                &nbsp;- {!!treatment_center.ended_at ? moment(treatment_center.ended_at).format("MM/DD/YYYY") : 'Unknown'}
              </div>
            }
          </div>
        ))
      }
    </div>
  )
}
